import { MessageSchema } from ".";

export default {
    action: {
        add: "Hinzufügen",
        create: "Erstellen",
        validate: "Bestätigen",        
        createNew: "Neu erstellen",
        update: "Bearbeiten",
        delete: "Löschen",
        confirm: "Bestätigen",
        cancel: "Abbrechen",
        close: "Schließen",
        save: "Speichern",
        clear: "Löschen",
        send: "Senden",
        search: "Suchen",
        print: "Drucken",
        import: "Importieren",
        synchronize: "Synchronisieren",
        share: "Teilen",
        duplicate: "Duplizieren",
        renew: "Erneuern",
        ok: "Ok",
        retry: "Wiederholen",
        REDIRECT_CALENDAR: "Erstellen und Termin vereinbaren",
        REDIRECT_FOLDER: "Erstellen und auf Akte zugreifen",
        correct: 'Korrigieren'
    },
    common: {
        info: "Info",
        title: "Titel",
        file: "Datei",
        url: "Url",
        default: "Standard",
        selection: "Auswahl",
        appointment: {
            status: {
                title: "Status",
                WAITING_ROOM: "Warteraum",
                SCHEDULED: "Geplant",
                HONOURED: "Wahrgenommen",
                NOT_HONOURED: "Nicht wahrgenommen",
                TO_VALIDATE: "Zu validieren",
                CANCELLED: "Abgesagt"
            },
            patientWarningMsg: 'Der Patient konnte nicht abgerufen werden, aber Sie können diesen Termin trotzdem bearbeiten.'
        },
        me: "Ich",
        yes: "Ja",
        no: "Nein",
        loading: "Laden ...",
        date: "Datum",
        from: "Vom",
        until: "Bis",
        amount: "Betrag",
        status: {
            'active': "Aktiv",
            'unactive': "Deaktiviert"
        },
        pageable: {
            showing: "Anzeige {first} bis {last} von {total}"
        },
        frequency: {
            EVERY_WEEK: "Jede Woche",
            EVERY_TWO_WEEKS: "Alle 2 Wochen",
            EVERY_THREE_WEEKS: "Alle 3 Wochen"
        },        
        honorifics: {
            NONE: "",
            MALE: "Herr",
            FEMALE: "Frau",
            NON_BINARY: ""
        },
        gender: {
            MALE: "Männlich",
            FEMALE: "Weiblich",
            NONE: "Nicht definiert",
            NON_BINARY: "Andere"
        },
        patient: 'Patient',
        patients: 'Patienten',
        healthPro: 'Gesundheitsfachkraft',
        healthPros: 'Gesundheitsfachkräfte',
        user: 'Benutzer',
        users: 'Benutzer',
        personRole: {
            HEALTHPRO: "Arzt",
            HEALTHPROASSISTANT: "Assistent",
            HEALTHPROSTUDENT: "Medizinstudent"
        },
        toast: {
            error: "Ein Fehler ist aufgetreten",
            warning: "Ungültige Aktion",
            success: {
                add: "Erfolgreich erstellt",
                update: "Erfolgreich aktualisiert",
                delete: "Erfolgreich gelöscht",
                cancel: "Erfolgreich abgebrochen",
                deactivate: "Erfolgreich deaktiviert",
            }
        },
        patientStatus: {
            WAITING: "Bevorstehend",
            LEAVE: "Abgeschlossen",
            OUT: "Patient ausgegangen"
        },
        newInput: "Hinzufügen: {inputValue}",
        version: "v{version}",
        calendar: {
            future: "Zukunft",
            now: "Aktuell",
            months: "1 Monat | {count} Monate",
            weeks: "1 Woche | {count} Wochen",
            days: "1 Tag | {count} Tage"
        },
        contactForm: {
            title: {
                phone: "Telefon",
                email: "E-Mail",
                address: "Adresse"
            },
            label: {
                phone: {
                    actionDefault: "Standardmäßig verwenden",
                    isDefault: "Standardmäßig verwendet"
                },
                address: {
                    actionDefault: "Standardmäßig verwenden",
                    isDefault: "Standardmäßig verwendet"
                },
                email: {
                    actionDefault: "Standardmäßig verwenden",
                    isDefault: "Standardmäßig verwendet"
                } 
            }
        }
    },
    error: {
        DEFAULT: "Ein Fehler ist aufgetreten",
        EXPRESSION_SAVE_FAILED: "Befund nicht gespeichert",
        REQUIRED: "Pflichtangabe",
        REDIRECT: "Weiterleitung nicht möglich",
        ACTION_FORBIDDEN: "Aktion nicht erlaubt",
        APPOINTMENT_TYPE_NOT_FOUND: "Unbekannter Termintyp",
        APPOINTMENT_TYPE_FORBIDDEN_EDIT: "Bearbeitung des Termintyps nicht erlaubt",
        INSTITUTE_WITH_ROLE_NOT_FOUND: "Unbekanntes Institut",
        USER_FORBIDDEN: "Sie haben keine Berechtigung für diese Aktion",
        USER_WITHOUT_AVAILABLE_MODULE: "Sie haben keinen Zugang zu den Anwendungsmodulen. Bitte kontaktieren Sie einen Administrator.",
        INSTITUTE_ADDRESS_NOT_FOUND: "Keine Adresse für dieses Institut",
        INSTITUTE_ADDRESS_FORBIDDEN_EDIT: "Bearbeitung dieser Adresse nicht erlaubt",
        INSTITUTE_ROOM_NOT_FOUND: "Unbekannter Warteraum",
        INSTITUTE_ROOM_FORBIDDEN_EDIT: "Bearbeitung des Warteraums nicht erlaubt",
        PERSON_ADDRESS_NOT_FOUND: "Unbekannte Adresse",
        PERSON_ELEMENT_NOT_ASSOCIATED: "Element ist nicht mit der Person verknüpft",
        PERSON_EMAIL_NOT_FOUND: "Unbekannte E-Mail-Adresse",
        PERSON_PHONE_NOT_FOUND: "Unbekannte Telefonnummer",
        PERSON_WITH_ROLE_NOT_FOUND: "Unbekannte Person",
        USER_AUTHENTICATED_FAILED: "Authentifizierung fehlgeschlagen",
        SETTINGS_WEEK_MODEL_NOT_FOUND: "Unbekannte Standardwoche",
        SETTINGS_WEEK_MODEL_NAME_EXIST: "Eine Standardwoche mit diesem Namen existiert bereits",        
        SETTINGS_DAY_MODEL_NOT_FOUND: "Unbekannter Standardtag",
        SETTINGS_DAY_MODEL_NAME_EXIST: "Ein Standardtag mit diesem Namen existiert bereits",
        APPOINTMENT_NOT_FOUND: "Unbekannter Termin",
        TIMESLOT_UNAVAILABLE: "Arzt an diesem Datum nicht verfügbar",
        EMPTY_LOCATION: "Warteraum ist erforderlich",
        HEALTH_GROUP_MEMBER_NOT_FOUND: "Unbekanntes Institut",
        SPECIAL_DAY_PERIOD_ALREADY_EXIST: "Ein besonderer Tag existiert bereits für dieses Datum",
        SPECIAL_DAY_NOT_FOUND: "Unbekannter besonderer Tag",
        SPECIAL_DAY_PERIOD_BEFORE_ERROR: "Enddatum kann nicht vor dem Startdatum liegen",
        APPOINTMENT_DATE_IN_PAST: "Sie können einen Termin, der bereits in der Vergangenheit liegt, nicht ändern",
        APPOINTMENT_ALREADY_FINISH: "Termin wurde bereits als beendet markiert",
        APPOINTMENT_CANCELED: "Der Termin wurde abgesagt, Sie können ihn nicht verschieben",
        APPOINTMENT_MOVE_DOCTOR_FORBIDDEN: "Sie können diesen Termin nicht auf einen anderen Arzt verlegen",
        APPOINTMENT_MOVE_TYPE_FORBIDDEN: "Sie können diesen Termin nicht in einen Termin anderer Art verschieben",
        MOVE_APPOINTMENT_IN_PROGRESS: "Ein Termin wird gerade verschoben",
        APPOINTMENT_MOVE_PATIENT_FORBIDDEN: "Sie können diesen Termin nicht auf einen anderen Patienten übertragen",
        APPOINTMENT_DURATION_TOO_LONG: "Ein Termin darf sich nicht über mehrere Tage erstrecken",
        DELETE_FORBIDDEN_NOT_CURRENT_ENTRY: "Löschen nicht möglich (Dieser Eintrag ist nicht in einer aktuellen Konsultation)",
        DELETE_FORBIDDEN_LAST_ITEM: "Löschen nicht möglich (Nur ein Eintrag in der Konsultation vorhanden)",
        DELETE_FORBIDDEN_NOT_SAP_CURRENT_ENTRY: "Löschen nicht möglich (Dieser Eintrag ist nicht in einer aktuellen Konsultation)",
        DELETE_FORBIDDEN_NOT_EMPTY_CONCLUSION: "Konsultation ist nicht leer",
        DELETE_FORBIDDEN_CONCLUSION_WITH_ORDER_1: "Die letzte Gruppe der Konsultation kann nicht gelöscht werden",
        DELETE_FORBIDDEN_EXPRESSION_TITLE_GROUP: "Löschen nicht möglich (dieser Eintrag wird in einer Gruppe verwendet)",
        VIDEO_NOT_FOUND: "Das angeforderte Video existiert nicht",
        VIDEO_UNVAILABLE: "Kein Video verfügbar",
        DIRECTORY_NOT_FOUND: "Das angeforderte Verzeichnis existiert nicht",
        TASK_BOX_MODULE_NOT_FOUND: "Aufgabenmodul existiert nicht",
        APP_USE_NOT_FOUND: "Benutzer existiert nicht",
        USER_NOT_IN_INSTITUT: "Benutzer gehört keinem Institut an",
        USER_SSN_EXIST: "LuxTrust-Kennung bereits vergeben",
        DOCTOR_HEALTH_GROUP_MEMBER_NOT_FOUND: "Unbekannter Arzt",
        PERSON_NOT_SPECIFIED: "Person nicht angegeben",
        INSTITUTE_NOT_SPECIFIED: "Institut nicht angegeben",
        INSTITUTE_WITHOUT_HEALTH_PRO_GROUP_ROLE: "Institut ohne definierte Rolle",
        CANNOT_DELETE_LAST_INSTITUTE_ADDRESS: "Die letzte Adresse eines Instituts kann nicht gelöscht werden",        
        PERSON_ALREADY_LINKED_WITH_INSTITUTE: "Person bereits mit diesem Institut verknüpft",
        CREATE_PERSON_ERROR: "Fehler beim Erstellen der Person",
        MANDATORY_DATA_MISSING: "Pflichtdaten fehlen",
        PERSON_GENDER_TYPE_ERROR: "Unbekanntes Geschlecht",
        PERSON_CNS_NUMBER_ERROR: "Ungültiges Format für Matricule",
        PERSON_CNS_BIRTHDATE_ERROR: "Diese Sozialversicherungsnummer entspricht keinem gültigen Geburtsdatum",
        IS_NOT_A_DOCTOR: "Benutzer ist kein Arzt",
        HAS_NO_PLANNING: "Kein geteilter Kalender",
        APPOINTMENT_MANDATORY: "Name und Dauer sind erforderlich",
        APPOINTMENT_TYPE_NAME_EXIST: "Ein Termintyp mit diesem Namen existiert bereits",
        APPOINTMENT_TYPE_NOTE_LENGTH: "Notiz darf 255 Zeichen nicht überschreiten",
        NO_PATIENT: "Ausgewählter Patient existiert nicht",
        FINANCIAL_GROUP_NOT_FOUND: "Unbekannte Finanzgruppe",
        FINANCIAL_CHANNEL_NOT_FOUND: "Unbekannter Finanzkanal",
        FINANCIAL_CHANNEL_AND_GROUP_ERROR: "Finanzkanal gehört nicht zur Finanzgruppe",
        FINANCIAL_BANK_ACCOUNT_NOT_FOUND: "Unbekannte Bankdaten",
        FINANCIAL_BANK_ACCOUNT_FORBIDDEN_EDIT: "Bankdaten können nicht bearbeitet werden",
        SETTINGS_CHANNEL_PERMISSION_NOT_FOUND: "Unbekannte Finanzkanalberechtignung",
        CNS_ALREADY_EXIST: "CNS-Code existiert bereits für eine andere Person",
        RELATION_ID_AND_PATIENT_ID_ARE_NULL: "Unbekannter Patient",
        CNS_AFFILIATION_NUMBER_SUFFIX_LENGTH: "Matrikelsuffix muss 5 Zeichen haben",
        CNS_HEALTH_INSURANCE_NOT_FOUND: "Unbekannte Matricule",
        GET_PERSON_ERROR: "Fehler beim Abrufen der Person",
        UPDATE_PERSON_ERROR: "Fehler beim Aktualisieren der Personendaten",
        TASKBOX_ALREADY_ASSIGN: "Aufgabe ist bereits 2 Personen zugewiesen",
        TASKBOX_RESULT_ALREADY_EXIST: "'Ergebnisse'-Aufgabe existiert bereits",
        PATIENT_DOCUMENT_GROUP_NOT_FOUND: "Dokumentengruppe existiert nicht",
        PERSON_AND_PATIENT_ALREADY_ASSOCIATED: "Person ist bereits mit Patient verknüpft",
        ADD_PERSON_TO_PATIENT_ERROR: "Ausgewählte Person kann diesem Patienten nicht hinzugefügt werden",
        INSTITUTE_PID_ACTIVE_BUT_NOT_HEALTH_GROUP_PRO: "Institut muss die Rolle Health Pro Group haben, um PID zu aktivieren",
        NO_DATA: "Die Sendedatei konnte nicht erstellt werden",
        HOSPI_DURATION_TOO_LONG: "Die Krankenhausaufenthaltsdauer überschreitet das Limit von {days} Tagen.",
        INVOICE_GENERATE_ERROR: "Fehler bei der Erstellung der Honorarabrechnung, bitte erneut versuchen",
        CNS_AFFILIATION_NUMBER_INVALID: "Ungültige Matricule",
        RELATION_ID_IS_NULL: "Fehlende Beziehungs-ID",
        CNS_NUMBER_IS_EMPTY: "Keine Matricule vorhanden.",
        INSTITUTE_ID_IS_NULL: "Fehlende Instituts-ID",
        FEE_WRONG_FORMAT: "Der Betrag muss eine Dezimalzahl sein",
        NO_PDFS_FOUND: "Keine PDFs gefunden",
        PDF_LOADING_ERROR: "Fehler beim Laden des PDFs",
        TIMESLOT_PERIOD_ALREADY_EXIST: "Eine Woche ist bereits für diesen Zeitraum konfiguriert",
        SETTINGS_WEEK_MODEL_USED: "Die Woche wird in einem Zeitraum verwendet",
        INSTITUTE_EMAIL_IS_USED: "Die E-Mail wird von einer oder mehreren Fachkräften verwendet",
        INSTITUTE_PHONE_IS_USED: "Die Telefonnummer wird von einer oder mehreren Fachkräften verwendet",
        INSTITUTE_ADDRESS_IS_USED: "Die Adresse wird von einer oder mehreren Fachkräften verwendet",        
        FINANCIAL_GROUP_MISSING_IBAN: "Die Honorarnote konnte nicht erstellt werden, da die IBAN der Finanzgruppe fehlt",
        SETTINGS_DAYS_BY_WEEK_MODEL_NOT_FOUND: "Unbekannte Tageseinstellung",
        FINANCIAL_GROUP_CODE_TOO_LONG: "Der Code der Finanzgruppe muss aus drei Zeichen bestehen",
        FINANCIAL_GROUP_MISA_TOO_LONG: "Die Misa-Nummer der Finanzgruppe muss aus acht Zeichen bestehen",
        FINANCIAL_GROUP_ONLY_ONE_PID: "Diese Finanzgruppe hat bereits einen PID-Kanal (nur einer erlaubt)",
        INSTITUTE_HEADER_NOT_FOUND: "Diese Kopfzeile wurde nicht gefunden",
        INSTITUTE_HEADER_CANNOT_DELETE_LAST: "Der letzte Kopfzeile des Instituts kann nicht gelöscht werden",
        INSTITUTE_HEADER_IS_USED: "Diese Kopfzeile wird von einer oder mehreren Personen verwendet",
        PATIENT_DOCUMENT_NOT_CURRENT_ENTRY: "Dieses Dokument gehört nicht zum aktuellen Eintrag",  
        HEALTH_PRO_HAS_APPOINTMENT: "Für diesen Angehörigen der Gesundheitsberufe ist ein Termin vereinbart",
        ENTRY_RELATION_NOT_FOUND: "Unbekannter Eintrag",
        NOT_ENTRY_FOR_THIS_PATIENT: "Dieser Eintrag steht in keinem Zusammenhang mit dem Patienten",
        NEW_DOSETIMING: "Für ein Medikament in diesem Eintrag wurde eine neue Dosierung festgelegt. Möchten Sie den Eintrag dennoch löschen ?",
        ECOSYSTEM_USED_ANOTHER_ENTRY: "Ein Ökosystem wird in einer anderen Abfrage verwendet. Möchten Sie den Löschvorgang fortsetzen ?",
        HISTORY_USED_ANOTHER_ENTRY: "Ein Eintrag wird in einer anderen Abfrage verwendet. Möchten Sie den Löschvorgang fortsetzen ?",
        MONITORING_USED_ANOTHER_ENTRY: "Ein Monitoring wird in einer anderen Konsultation verwendet. Möchten Sie den Löschvorgang fortsetzen ?",
        BASIC_USED_ANOTHER_ENTRY: "Ein Konzept wird in einer anderen Konsultation verwendet. Möchten Sie den Löschvorgang fortsetzen ?"
    },
    warn: {
        APPOINTMENT_EXIST: "Achtung, Termine wurden für dieses Datum geplant.",
        TOO_LONG: "Achtung, Termindauer überschreitet verfügbares Zeitfenster",
        NO_TIME_SLOT_FOR_APPT_TYPE_MSG: "Dieser Termintyp ist für diese Zeit nicht konfiguriert",
        ONE_DOCTOR_SELECTED: "Mindestens ein Arzt muss ausgewählt werden",
        INVALID_DATE_TIME: "Ungültiges Datumsformat"
    },
    enum: {
        languages: {
            FR: 'Französisch',
            EN: 'Englisch',
            DE: 'Deutsch',
            ES: 'Spanisch',
            IT: 'Italienisch',
            PT: 'Portugiesisch',
            NL: 'Niederländisch',
            LU: 'Luxemburger'
        },
        weekday: {
            MONDAY: "Montag",
            TUESDAY: "Dienstag",
            WEDNESDAY: "Mittwoch",
            THURSDAY: "Donnerstag",
            FRIDAY: "Freitag",
            SATURDAY: "Samstag",
            SUNDAY: "Sonntag"
        }
    },
    menu: {
        settings: 'Einstellungen',
        admin: 'Admin',
        logout: 'Abmelden',
        help: 'Hilfe',
        tutorial: {
            videoNotDisplay: 'Ihr Browser unterstützt keine Videowiedergabe',
            selectVideo: 'Video auswählen'
        },
        idea: 'Ideenbox',
        news: 'eSklepios Neuigkeiten',
        version: "Version {version}",
        contactSupport: "Technischen Support kontaktieren",
        fullscreen: 'Vollbild',
        institute: 'Institut'
    },
    academic: {
        menu: {
            mycme: "my cme",
            cmePulication: "alformec",
            cmeValidation: "Akkreditierung"
        }
    },
    office: {
        menu: {
            incomes: "Einnahmen",
            expenses: "Ausgaben",
            stock: "Lager",
            orders: "Bestellungen"
        }
    },
    settings: {
        notification: {
            reminderTitle: "Erinnerungsbenachrichtigungen für Termine",
            isTodayReminderEnabled: "Am selben Tag",
            isOneDayBeforeReminderEnabled: "Am Vortag",
            isThreeDaysBeforeReminderEnabled: "Drei Tage vorher",
            isOneWeekReminderEnabled: "Eine Woche vorher"
        },
        titleLabels: {
            title1: 'Titel 1',
            title2: 'Titel 2',
            title3: 'Titel 3',
            title4: 'Titel 4',
            title5: 'Titel 5',
            title6: 'Titel 6'
        },
        permissions: {
            institutes: "Institute"
        },
        menu: {
            duration: "{numberMin} Min",
            organization: "Institut",
            mySettings: "Meine Einstellungen",
            appointmentTypes: "Termintypen",
            waitingRoom: "Warteräume",
        },
        title: {
            language: "Sprache",
            appointment: "Termine",
            appointmentType: "Liste der Termintypen"
        },
        tab: {
            main: "Allgemein",
            appointmentTye: "Termintypen",
            specialDays: "Besondere Tage",
            planning: "Planning",
            dayModel: "Standardtage"
        },
        calendar: {
            noHealthPro: "Sie haben keinen konfigurierbaren Kalender"
        },
        label: {
            main: {
                subtitle: {
                    calendar: "Kalendereinstellungen"
                },
                duration: {
                    label: "Dauer eines Terminfensters (in Min.)",
                    success: {
                        update: "Dauer des Terminfensters erfolgreich aktualisiert"
                    }
                },
                beforeDay: {
                    label: "Maximale Vorausbuchung für Patienten (in Tagen)",
                    success: {
                        update: "Anzahl der Tage erfolgreich aktualisiert"
                    }
                },
                cancelHour: {
                    label: "Mindest-Stornierungsfrist für Patienten (in Stunden vor dem Termin)",
                    success: {
                        update: "Anzahl der Stunden erfolgreich aktualisiert"
                    }
                },
                generalMessage: {
                    label: "Mitteilung für Patienten",
                    success: {
                        update: "Mitteilung erfolgreich aktualisiert"
                    }
                },
                permissions: {
                    title: "Zugriff auf meinen Kalender",
                    loading: "Laden ...",
                    empty: "Keine Berechtigungen definiert",
                    access: "Zugriff",
                    admin: "Administration",
                    message: {
                        success: {
                            update: "Berechtigung erfolgreich aktualisiert"
                        }
                    }
                },
                weekDay: "Im Kalender anzuzeigende Tage",
                message: {
                    success: {
                        update: "Anzeigetage erfolgreich aktualisiert"
                    }
                }
            },
            select: {
                institutes: "Institut",
                healthpros: "Behandler"
            },
            specialDays: {
                modal: {
                    header: "Zeiten eines besonderen Tages bearbeiten",
                    date: "Datum",
                    range: "Zeitraum auswählen",
                    dayModel: "Standardtag",
                    period: "Zeitraum",
                    add: {
                        title: "Besonderen Tag erstellen",
                    },
                    delete: {
                        title: "Besonderen Tag löschen",
                        message: "Sie sind dabei, einen besonderen Tag zu löschen",
                    }
                },
                toast: {
                    created: "Besonderer Tag erfolgreich erstellt",
                    updated: "Besonderer Tag erfolgreich aktualisiert",
                    deleted: "Besonderer Tag erfolgreich gelöscht",
                },
                labelQuickParam: "Besonderer Tag vom {specialDayDate}"
            },
            weekModel: {
                message: {
                    success: {
                        update: "Standardwoche erfolgreich aktualisiert"
                    }
                },
                nameOfNew: "Neue Standardwoche {counter}",
                action: {
                    add: {
                        button: "Wochentyp hinzufügen"
                    }
                }
            },
            planning: {
                action: {
                    openWeekModel: "Standardwochen verwalten",
                    addTimeslot: "Zeitraum hinzufügen",
                    deleteSelected: "Ausgewählte Zeiträume löschen"
                },
                weekModel: {
                    header: "Verwaltung der Standardwochen",
                    weekStandard: "Standardwoche"
                },
                noData: "Kein Zeitraum konfiguriert",
                column: {
                    slot: "Zeitraum",
                    weekModel: "Angewandte Standardwoche"
                },
                tooltip: "Mindestens ein besonderer Tag ist in diesem Zeitraum enthalten. Besondere Tage ersetzen die Konfiguration der gewählten Woche.",
                modale: {
                    delete: {
                        header: "Zeitraum löschen",
                        message: "Sie sind dabei, einen Zeitraum zu löschen"
                    },
                    deleteSelected: {
                        header: "Zeiträume löschen",
                        message: "Sie sind dabei, mehrere Zeiträume zu löschen"
                    },
                    addTimeslot: {
                        header: "Zeitraum hinzufügen",
                        startDate: "Startdatum",
                        endDate: "Enddatum",
                        frequency: "Häufigkeit",
                        weekModel: "Standardwoche",
                        startDateRequired: "Bitte geben Sie das Startdatum ein",
                        endDateRequired: "Bitte geben Sie das Enddatum ein",
                        frequencyRequired: "Bitte geben Sie die Häufigkeit ein",
                        weekModelRequired: "Bitte geben Sie die Standardwoche ein",
                        warning: "Wenn der neue Zeitraum einen bereits konfigurierten Zeitraum überlappt, wird die bestehende Konfiguration durch die neue ersetzt."
                    }
                },
                message: {
                    success: {
                        delete: "Zeitraum erfolgreich gelöscht",
                        update: "Zeitraum erfolgreich geändert",
                        add: "Zeitraum erfolgreich hinzugefügt"
                    }
                }
            },            
            dayModel: {
                unavailable: "Standard-Nichtverfügbarkeitsvorlage. Keine Konfiguration erforderlich",
                selectOrCreate: "Standardtag auswählen oder erstellen",
                form: {
                    name: "Name",
                    timeslot: {
                        start: "Beginn",
                        end: "Ende",
                        delete: "Löschen"
                    },
                    header: {
                        add: "Standardtag hinzufügen",
                        name: "Standardtag-Name bearbeiten",
                        timeslot: "Standardtag-Zeiten bearbeiten",
                        delete: "Standardtag löschen"
                    },
                    message: {
                        delete: "Sie sind dabei, einen Standardtag zu löschen",
                        success: {
                            add: "Tag erfolgreich hinzugefügt",
                            update: "Tag erfolgreich geändert",
                            timeslot: "Standardtag-Zeiten erfolgreich geändert",
                            delete: "Standardtag erfolgreich gelöscht"
                        }
                    }
                }
            },
            appointmentType: {
                fieldColor: "Farbe",
                name: "Name",
                order: "Reihenfolge",
                duration: "Dauer",
                note: "Nachricht für Patienten",
                offline: "Portal-Terminbuchung",
                action: "Aktion",
                online: "Offen",
                patient: "Für vertrauenswürdige Patienten reserviert",
                offlineStatus: "Nicht verfügbar",
                durationUnit: "{count} Min x",
                explanationDuration: "Die Dauer ist das Produkt aus dem bei der Erstellung eingegebenen Wert und der im Tab \"Allgemein\" festgelegten Standarddauer.",
                delete: {
                    header: "Termintyp löschen",
                    message: "Sie sind dabei, einen Termintyp zu löschen"
                },
                add: {
                    header: "Termintyp hinzufügen"
                },
                update: {
                    name: "Termintyp-Name bearbeiten"
                },
                message: {
                    success: {
                        update: "Typ erfolgreich aktualisiert",
                        add: "Typ erfolgreich hinzugefügt",
                        delete: "Typ erfolgreich gelöscht"
                    }
                }
            },
            waitingRoom: {
                name: "Name",
                nameRequired: "Bitte geben Sie einen Namen ein",
                maxLivePlaces: 'Maximale Kapazität',
                address: "Adresse",
                badge: "Abzeichen",
                noBadge: "Kein Abzeichen",
                noAddress: "Keine Adresse",
                byDefault: "Standard",
                street: "Straße",
                action: "Aktion",
                add: {
                    header: "Warteraum hinzufügen"
                },
                edit: {
                    header: "Warteraum bearbeiten"
                },
                delete: {
                    header: "Warteraum löschen",
                    message: "Sie sind dabei, einen Warteraum zu löschen"
                },
                message: {
                    success: {
                        update: "Warteraum erfolgreich aktualisiert",
                        add: "Warteraum erfolgreich hinzugefügt",
                        delete: "Warteraum erfolgreich gelöscht"
                    }
                }
            },
            instituteInformation: {
                name: "Name",
                action: "Aktion",
            },
            accounting: {
                financialGroup: {
                    title: "Gruppen",
                    unactive: "Finanzgruppe ist deaktiviert",
                    optionDisabled: "{name} (deaktiviert)",
                    table: {
                        code: "Code",
                        title: "Titel",
                        active: "Aktiv",
                        empty: "Keine Finanzgruppe"
                    },
                    message: {
                        success: {
                            update: "Finanzgruppe erfolgreich aktualisiert",
                            add: "Finanzgruppe erfolgreich hinzugefügt"
                        }
                    },
                    form: {
                        header: {
                            add: "Finanzgruppe hinzufügen",
                            update: "Finanzgruppe bearbeiten"
                        },
                        code: "Code",
                        personalInfo: "Zusatzinfo",
                        title: "Titel",
                        iban: "IBAN",
                        bic: "BIC-Code"
                    },
                    financialChannel: {
                        empty: "Finanzgruppe auswählen oder erstellen",
                        add: {
                            action: "Kanal hinzufügen",
                            header: "Kanal hinzufügen",
                            message: {
                                success: "Kanal erfolgreich hinzugefügt"
                            }
                        },
                        permissions: {
                            title: "Berechtigungen für diese Gruppe",
                            payment: "Zahlungen",
                            edition: "Änderungen",
                            creation: "Erstellen"
                        },
                        type: {
                            None: "Keine",
                            BankAccount: "Bankkonto",
                            BankCard: "Bankkarte",
                            Cash: "Bargeld",
                            LuPid: "Pid",
                            DigitalPayment: "Digitale Zahlung",
                            LuTp: "Tp",
                            LuTpSocial: "Sozial-Tp",
                            Cancelled: "Storniert"
                        },
                        data: {
                            title: "Titel",
                            type: "Typ",
                            active: "Aktiv",
                            bank: {
                                fullName: "Name",
                                shortName: "Kurzname",
                                bic: "BIC-Code",
                                iban: "IBAN"
                            }
                        },
                        update: {
                            title: "Kanaltitel bearbeiten",
                            message: {
                                success: "Kanal erfolgreich geändert"
                            }
                        },
                        error: {
                            missingIban: "Ein Bankkonto kann nicht aktiv sein und keinen IBAN haben"
                        }
                    }
                }
            },
            patient: {
                managementDelegate: {
                    title: "Patienteneintrag in meinem Namen erstellen",
                    loading: "Laden ...",
                    empty: "Keine Delegation definiert",
                    update: {
                        message: {
                            success: "Delegation erfolgreich geändert"
                        }
                    }
                }
            },
            account: {
                institute: {
                    preference: {
                        header: "Kontaktpräferenz für {instituteName}",
                        headerLines: "Kopfzeile",
                        address: "Adresse",
                        phone: "Telefon",
                        email: "E-Mail",
                        warning: "Diese Daten werden auf den von der Anwendung generierten Dokumenten (Rezepte, Honorarabrechnungen) und dem Terminbuchungsportal sichtbar sein.",
                        message: {
                            success: "Präferenzen erfolgreich aktualisiert"
                        }
                    }
                }
            },
            task: {
                taskbox: {
                    title: "Aufgaben",
                    add: {
                        header: "Aufgabe hinzufügen",
                        message: {
                            success: "Aufgabe erfolgreich hinzugefügt"
                        }
                    },
                    update: {
                        header: "Aufgabe bearbeiten",
                        message: {
                            success: "Aufgabe erfolgreich geändert"
                        }
                    },
                    data: {
                        title: "Titel",
                        module: "Modultyp"
                    },
                    moduleType: {
                        NONE: "Keine",
                        PATIENT: "Patient",
                        ACCOUNTING: "Buchhaltung",
                        STOCK: "Lager",
                        STAFF: "Personal",
                        LEARNING: "Lernen",
                        TEACHING: "Lehre",
                        RESEARCH: "Forschung"
                    },
                    channelType: {
                        NONE: "Keine",
                        RESULTS: "Ergebnis",
                        TWOPERSON: "Zwei Personen",
                    }
                }
            }
        },
        error: {
            numberMaxChar: "Feld darf nicht mehr als 255 Zeichen haben",
        },
        params: {
            title: "Einstellungen",
            tabs: {
                billing: "Abrechnung"
            },
            preferences: {
                title: "Einstellungen",
                subTitle: "Einstellungen",
                language: {
                    title: "Sprache",
                    menus: "Menüs",
                    snomedct: "Texterkennung",
                },
                suggestions: {
                    title: "Vorschläge",
                    humanBody: "Körperdiagramm",
                    neuro: "Neuro",
                    ent: "ENT",
                    thorax: "Thorax",
                    abdomen: "Abdomen",
                    lymph: "Lymph",
                },
                clinical: {
                    title: "Klinisch",
                    reducedByDefault: "Konsultationen standardmäßig reduziert",
                    dashboardOphtalmo: "Ophthalmologie-Dashboard",
                },
            },
            account: {
                details: {
                    title: 'Titel',
                    address: "Adressen",
                    contact: "Kontakte",
                    email: "Adresse",
                    mobile: "Handy",
                    phone: 'Nummer',
                    note: "Notiz"
                },
                prescription: {
                    header: "Kopfzeile",
                    labelTitleLine1: "Kopfzeile 1 auf Rezept",
                    labelTitleLine2: "Kopfzeile 2 auf Rezept",
                    labelCustomLine1: "Kopfzeile 1",
                    labelCustomLine2: "Kopfzeile 2",
                    instituteName: "Institutsname",
                    instituteFullName: "Vollständiger Name",
                    instituteShortName: "Kurzname",
                    title: "Rezept-Kopfzeilen"
                },
                institutes: {
                    roles: {
                        admin: "Administrator",
                        customLearningSpeaker: "Ersteller medizinischer Fortbildung",
                        customPatient: "Patient",
                        healthPro: "Arzt",
                        healthProAssistant: "Sekretär"
                    },
                    title: "Institute",
                    portailPatient: {
                        title: "Patientenportal-Informationen",
                        parking: {
                            title: "Parkplätze",
                            nameRequired: "Bitte geben Sie einen Namen ein",
                            add: "Parkplatz hinzufügen",
                            update: "Parkplatz bearbeiten",
                            delete: "Parkplatz löschen",
                            message: "Sie sind dabei, einen Parkplatz zu löschen",
                        },
                        transportStop: {
                            title: "Öffentlicher Nahverkehr",
                            nameRequired: "Bitte geben Sie einen Namen ein",
                            add: "Haltestelle hinzufügen",
                            update: "Haltestelle bearbeiten",
                            delete: "Haltestelle löschen",
                            message: "Sie sind dabei, eine Haltestelle zu löschen",
                        },
                        slug: {
                            title: "URL des Instituts",
                            format: 'Buchstaben ohne Akzente und ohne Zahlen, durch Bindestriche getrennt',
                            formatError: "Die URL entspricht nicht dem zulässigen Format",
                            mandatory: "Die URL ist erforderlich",
                            alreadyUsed: "Diese URL ist bereits vorhanden, bitte wählen Sie eine andere aus",
                            success: "URL erfolgreich geändert",
                            error: "Fehler beim Aktualisieren der URL"
                        },
                        generalMessage: {
                            title: "Informationsmeldung",
                        },
                    }
                },
                title: "Konto",
                toast: {
                    add: {
                        address: "Adresse erfolgreich hinzugefügt",
                        email: "E-Mail-Adresse erfolgreich hinzugefügt",
                        phone: "Telefonnummer erfolgreich hinzugefügt",
                        header: "Kopfzeile erfolgreich hinzugefügt",
                    },
                    delete: {
                        address: "Adresse erfolgreich gelöscht",
                        email: "E-Mail-Adresse erfolgreich gelöscht",
                        phone: "Telefonnummer erfolgreich gelöscht",
                        parking: "Parkplatz erfolgreich gelöscht",
                        stop: "Haltestelle erfolgreich gelöscht",
                        header: "Kopfzeile erfolgreich gelöscht",
                    },
                    update: {
                        address: "Adresse erfolgreich geändert",
                        email: "E-Mail-Adresse erfolgreich geändert",
                        phone: "Telefonnummer erfolgreich geändert",
                        information: "Informationen erfolgreich geändert",
                        header: "Kopfzeile erfolgreich aktualisiert",
                    }
                },
                subTitle: "Persönliche Daten",
                portailPatient: {
                    title: "Patientenportal-Informationen",
                    fees: "Gebühren",
                    meanOfPayement: "Zahlungsmethoden",
                    presentation: "Vorstellung",
                    diploma: "Abschlüsse",
                    teleconsultation: "Telekonsultation verfügbar",
                    openToNewPatient: "Offen für neue Patienten",
                    showAgenda: "Zeitplan anzeigen",
                    showContact: "Auf dem Portal anzeigen",
                    schedule: "Öffnungszeiten",
                    complementaryInformation: "Zusätzliche Informationen",
                    generalMessage: "Informationsmeldung",
                    slug: {
                        title: "URL des Portals",
                        format: 'Buchstaben ohne Akzente und ohne Zahlen, durch Bindestriche getrennt',
                        formatError: "Die URL entspricht nicht dem zulässigen Format",
                        mandatory: "Die URL ist erforderlich",
                        alreadyUsed: "Diese URL ist bereits vorhanden, bitte wählen Sie eine andere aus",
                        success: "URL erfolgreich geändert",
                        error: "Fehler beim Aktualisieren der URL",
                        noInstituteSlugs: "Auf dem Portal sind keine Institute verfügbar"
                    },
                }
            },
            institute: {
                title: "Institut",
                subTitle: "Institutsdaten"
            },
            patient: {
                title: "Patientenakten",
                subTitle: "Patientendaten"
            },
            docPatient: {
                title: "Patientendokumente",
                subTitle: "Patientendokumente"
            },
            calendar: {
                title: "Kalender",
                subTitle: "Kalender"
            },
            task: {
                title: "Aufgaben",
                subTitle: "Aufgaben"
            },
            waitingRoom: {
                title: "Warteräume"
            },
            tasks: {
                title: "Aufgaben",
                subTitle: "Aufgaben",
                patientnote: "Aktennotiz",
                clinic: "Klinische Notiz",
                admin: "Administrative Notiz"
            },
            billing: {
                title: "Abrechnung",
                subTitle: "Abrechnung"
            },
            permission: {
                title: "Berechtigungen",
                subTitle: "Berechtigungen",
                update: "Berechtigung geändert"
            },
            notification: {
                title: "Benachrichtigungen",
                subTitle: "Benachrichtigungen"
            }
        },
        permission: {
            viewUsers: "Benutzer anzeigen",
            editUsers: "Benutzer bearbeiten",
            writePrescriptions: "Rezepte ausstellen",
            viewAppointments: "Termine anzeigen",
            empty: "Keine Berechtigung",
            roles: {
                admin: {
                    label: "Institutsverwaltung",
                    ADMIN_INSTITUTE: "Institutsverwaltung",
                },
                prescription: {
                    label: "Rezept",
                    WRITE_PRESCRIPTION: "Rezept erstellen/bearbeiten",
                    READ_PRESCRIPTION: "Rezept lesen",
                    SIGN_PRESCRIPTION: "Rezept unterschreiben"
                },
                task: {
                    label: "Aufgaben / Missionen",
                    ACCESS_TASK: "Zugriff auf Aufgabenmodul"
                },
                patient: {
                    label: "Patient",
                    ADD_PATIENT_DOCUMENT: "Verwaltungsdokument erstellen",
                    MODIFY_PATIENT_DATA: "Klinische Patientenakte ändern",
                    READ_PATIENT_DATA: "Klinische Akten von mit Institut verknüpften Patienten einsehen",
                    DELETE_PATIENT_DOCUMENT: "Verwaltungsdokument löschen",
                    EDIT_PATIENT_ADMIN_DATA: "Administrative Patientendaten bearbeiten"
                },
                planning: {
                    label: "Kalender",
                    CREATE_PLANNING: "Zeitplan erstellen",
                    ACCESS_PLANNING: "Zugriff auf Kalendermodul",
                    MODIFY_PLANNING: "Zeitplan bearbeiten",
                    OWNER_PLANNING: "persönlicher Terminkalender"
                },
                accounting: {
                    label: "Buchhaltungsverwaltung",
                    ACCESS_ACCOUNTING: "Zugriff auf Buchhaltungsmodul"
                }
            },
            datatableTitle: "Liste der Gesundheitsfachkräfte",
            title: "Berechtigungen für {name}"
        }
    },
    layout: {
        agenda: "Kalender",
        task: "Aufgaben",
        patient: "Patient",
        waitingroom: "Warteraum",
        finance: "Buchhaltung",
        forum: "Nachrichten",
        settings: "Einstellungen",
        material: "Ausrüstung",
        fastPatientCreation: 'Neuer Patient',        
        staff: "Personal"
    },
    admin: {
        subMenu: {
            title: "Verwaltung",
            institute: "Institute",
            medicalPerson: "Gesundheitsfachkräfte",
            permissions: "Berechtigungen",
            financialGroups: "Finanzgruppen",
            notifications: "Benachrichtigungen"
        },
        financialGroup: {
            datatableTitle: "Liste der gemeinsamen Finanzgruppen",
            search: "Suche",
            table: {
                title: "Name",
                code: "Code",
                active: "Aktiv",
                empty: "Keine Finanzgruppe",
                misaNumber: "Misa-Nummer",
                personalInfo: "Zusatzinfo",
                medicalPerson: "Gesundheitsfachkräfte"
            },
            form: {
                add: {
                    header: "Gemeinsame Finanzgruppe hinzufügen",
                    message: {
                        success: "Gemeinsame Finanzgruppe erfolgreich hinzugefügt"
                    }
                },
                update: {
                    header: "Gemeinsame Finanzgruppe bearbeiten",
                    message: {
                        success: "Gemeinsame Finanzgruppe erfolgreich geändert"
                    }
                },
                code: "Code",
                title: "Name",
                misaNumber: "Misa-Nummer",
                personalInfo: "Zusatzinfo",
                active: "Aktiv"
            },
            person: {
                title: "Gesundheitsfachkräfte der Gruppe {title}",
                search: "Suche",
                table: {
                    empty: "Keine Gesundheitsfachkraft",
                    name: "Vollständiger Name",
                    role: "Rolle",
                    active: "Aktiv",
                    isOwner: "Gruppenadministrator",
                    delete: "Löschen"
                },
                form: {
                    institute: "Institut",
                    person: "Gesundheitsfachkraft",
                    isOwner: "Gruppenadministrator",
                    ownerWarning: "Nur ein Administrator möglich. Diese Aktion entfernt bestehende Administratorrechte."
                },
                add: {
                    message: {
                        success: "Gesundheitsfachkraft erfolgreich hinzugefügt"
                    }
                },
                update: {
                    header: {
                        confirm: "Administrator-Änderung"
                    },
                    message: {
                        success: "Gesundheitsfachkraft erfolgreich geändert"
                    }
                },
                delete: {
                    modale: {
                        header: "Zugriff für Gesundheitsfachkraft löschen",
                        message: "Sie sind dabei, den Finanzgruppenzugriff für eine Gesundheitsfachkraft zu löschen",
                        messageOwner: "Sie sind dabei, den Finanzgruppenzugriff für den Administrator zu löschen"
                    },
                    message: {
                        success: "Zugriff der Gesundheitsfachkraft erfolgreich gelöscht"
                    }
                }
            }
        },
        institute: {
            search: "Suche",
            table: {
                name: "Name",
                instituteRole: "Rolle",
                active: "Aktiv",
                empty: "Kein Institut",
                admin: "Administrator",
                update: "Bearbeiten"
            },
            label: {
                add: {
                    header: "Institut hinzufügen",
                    message: {
                        success: "Institut erfolgreich hinzugefügt"
                    }
                },
                update: {
                    header: "Institut bearbeiten",
                    message: {
                        success: "Institut erfolgreich geändert"
                    }
                }
            },
            form: {
                data: "Informationen",
                name: "Name",
                shortName: "Kurzname",
                role: "Rolle",
                address: "Adresse",
                street: "Hausnummer und Straße",
                locality: "Stadt",
                postalCode: "Postleitzahl",
                country: "Land",
                userAdmin: "Administrator",
                options: "Optionen",
                pidActivation: "PID",
                fastPatientCreationActive: 'Schnelle Patientenerstellung',
                ophthalmoDashboard: 'Ophthalmologie-Dashboard',                
                externalId: "Externe ID",
            },
            person: {
                title: "Administratoren des Instituts {name}",
                search: "Suche",
                table: {
                    empty: "Kein Administrator",
                    firstname: "Vorname",
                    lastname: "Nachname",
                    role: "Rolle"
                },
                add: {
                    message: {
                        success: "Administrator erfolgreich hinzugefügt"
                    }
                },
                header: {
                    generalInfo: "Allgemeine Informationen",
                    options: "Optionen"
                },
                form: {
                    firstname: "Vorname",
                    lastname: "Nachname",
                    gender: "Geschlecht",
                    birthdate: "Geburtsdatum",
                    title: "Titel",
                    role: "Typ",
                    misaNumber: "Arztcode",
                    nlpPref: "Snomed CT-Sprache",
                    ssnLt: "Luxtrust-Kennung",
                    favoritePhone: "Telefon",
                    favoriteEmail: "E-Mail",
                    favoriteLanguage: "Gesprochene Sprachen",
                    portalPatientModule: "Patientenportal",
                    iban: "IBAN",
                    bic: "BIC"
                }
            }
        },
        medicalPerson: {
            table: {
                name: "Fachkraft",
                active: "Aktiv",
                institut: "Institute",
                role: "Rolle",
                empty: "Keine Fachkraft",
                update: "Bearbeiten"
            },
            institute: {
                title: "Institute von {name}",
                search: "Suche",
                table: {
                    empty: "Kein Institut",
                    name: "Institutsname",
                    role: "Rolle",
                    active: "Status",
                    isAdmin: "Administrator",
                    edit: "Bearbeiten",
                    delete: "Löschen"
                },
                form: {
                    institute: "Institut",
                    adminPermission: "Administrator"
                },
                add: {
                    message: {
                        success: "Institut erfolgreich hinzugefügt"
                    }
                },
                edit: {
                    message: {
                        success: "Institut erfolgreich geändert"
                    }
                },
                delete: {
                    modale: {
                        header: "Person löschen",
                        message: "Sie sind dabei, eine mit dem Institut verknüpfte Person zu löschen"
                    },
                    message: {
                        success: "Gesundheitsfachkraft erfolgreich gelöscht"
                    }
                }
            },
            form: {
                header: {
                    add: "Gesundheitsfachkraft hinzufügen",
                    update: "Gesundheitsfachkraft bearbeiten"
                },
                message: {
                    success: {
                        add: "Gesundheitsfachkraft erfolgreich hinzugefügt",
                        update: "Gesundheitsfachkraft erfolgreich geändert"
                    }
                }
            }
        },
        notifications: {
            message: {
                success: {
                    add: "Benachrichtigungsvorlage erfolgreich hinzugefügt",
                    update: "Benachrichtigungsvorlage erfolgreich geändert"
                }
            },
        },
    },
    calendar: {
        header: {
            weekDays: "Von {first} bis {last} ",
            todayButton: "Heute",
            pastButton: "Zurück",
            nextButton: "Weiter",
            withoutAppointment: "Ohne Termin",
            tab: {
                day: "Tag",
                week: "Woche"
            },
            appointment: "Termin für :",
            moveAppointment: "Verschiebung des Termins vom {date} um:"
        },
        menu: {
            calendar: "Kalender"
        },
        alt: {
            patient: "Patient"
        },
        label: {
            notAccess: "Sie haben keinen Zugriff auf einen Kalender. Um einen Kalender zu erhalten, wenden Sie sich bitte an den Administrator Ihrer Einrichtung.",
            forbidden: "{name} hat keinen Zugriff auf das Kalendermodul",
            update: {
                header: "Termin bearbeiten"
            },
            add: {
                patientWithoutAppointmentHeader: "Neuer Patient ohne Termin",
                header: "Neuer Termin",
                form: {
                    date: "Datum",
                    time: "Uhrzeit",
                    duration: "Dauer (in Minuten)",
                    appointmentType: "Termintyp",
                    patient: "Patient",
                    portalPatient: "Termin gebucht von",
                    healthPro: "Gesundheitsfachkräfte",
                    comment: "Kommentar",
                    departure: "Abfahrtszeit",
                    arrival: "Ankunft im Warteraum",
                    created: "Erstellt am ",
                    createdAt: "{date} um {time}",
                    createdAtBy: "{date} um {time} von {author}",
                    addPerson: "Neuer Patient",
                    lastname: "Nachname",
                    firstname: "Vorname",
                    favoritePhone: "Telefon",
                    mobile: "Mobil",
                    mail: "E-Mail",
                    isPatientWithoutAppointment: "Patient ohne Termin",
                    portalError: 'Beim Laden der Patientendaten ist ein Fehler aufgetreten.'
                }
            },
            delete: {
                action: "Termin stornieren"
            },
            move: {
                action: "Termin verschieben",
                disabled: "Ein Termin ist bereits ausgewählt, um ihn zu verschieben"
            },
            message: {
                success: {
                    add: "Termin erfolgreich hinzugefügt",
                    update: "Termin erfolgreich geändert"
                },
                error: {
                    commentLength: "Feld darf nicht mehr als 256 Zeichen haben"
                }
            },
            settings: {
                header: "Besonderer Tag vom {date}"
            },
            existAppointment: {
                header: "Ein Termin ist bereits geplant",
                message: {
                    create: "Für diesen Zeitraum ist bereits ein Termin geplant. Möchten Sie mit der Erstellung fortfahren?",
                    update: "Für diesen Zeitraum ist bereits ein Termin geplant. Möchten Sie mit der Änderung fortfahren?"
                }
            },
        },
        appointment: {
            action: {
                finish: "Abreise bestätigen",
                patientStatus: "Konsultation",
                start: "Ankunft bestätigen",
                restart: "Rückkehr bestätigen",
            },
            delete: {
                modale: {
                    header: "Termin stornieren",
                    message: "Sie sind dabei, einen Termin zu stornieren"
                },
                message: {
                    success: "Termin erfolgreich storniert"
                }
            }
        },
        waiting: {
            title: "Warteräume",
            room: {
                default: "Unbekannt",
                location: "Warteraum"
            },
        },
        history: {
            title: "Verlauf",
        },
        withoutAppointment: {
            title: "Ohne Termin",
        }
    },
    thirdPerson: {
        create: {
            title: {
                private: "Dritte Person für {name} erstellen",
                pro: "Gesundheitsfachkraft für {name} erstellen",
            },
            form: {
                firstname: "Vorname",
                lastname: "Nachname",
                address: "Adresse",
                street: "Hausnummer und Straße",
                postalCode: "Postleitzahl",
                locality: "Stadt",
                country: "Land",
                favoritePhone: "Telefon",
                mobile: "Mobil",
            },
            message: {
                success: {
                    add: "Person erfolgreich hinzugefügt"
                },
            }
        },
    },
    healthPro: {
        select: "Gesundheitsfachkraft auswählen",
        search: {
            placeholder: "Name ...",
            noResult: "Keine Ergebnisse",
        },
    },
    patient: {
        common: {
            bio: "Labor",
            biology: "Labor",
            imaging: "Bildgebung",
            medication: "Medikamente",
            report: "Bericht",
            reports: "Berichte",
            certificate: "Zertifikat",
            certificates: "Zertifikate",
        },
        addMedication: {
            placeholder: "Name oder INN ...",
            commercialNames: "Handelsnamen",
            singleSubstances: "Substanzen",
            multipleSubstances: "Mehrere Substanzen",
        },
        addMonitored: {
            childFollowUp: "Kinderbetreuung",
            adultFollowUp: "Erwachsenenbetreuung",
            pregnancyFollowUp: "Schwangerschaftsbetreuung",
            travelFollowUp: "Reisebetreuung",
            favorites: "Favoriten",
        },
        addHistory: {
            stroke: "Schlaganfall",
            dementia: "Demenz",
            parkinson: "Parkinson",
            epilepsy: "Epilepsie",
            migraine: "Migräne",
            adhd: "ADHS",
            depressiveDisorder: "Depressive Störung",
            anxietyDisorder: "Angststörung",
            bipolarDisorder: "Bipolare Störung",
            addictionTo: "Abhängigkeit von",
            anorexia: "Anorexie",
            bulimia: "Bulimie",
            autisticDisorder: "Autistische Störung",
            schizophrenia: "Schizophrenie",
            refractionDisorders: "Refraktionsfehler",
            refractionDisordersRightEye: "Refraktionsfehler rechtes Auge",
            refractionDisordersLeftEye: "Refraktionsfehler linkes Auge",
            cataract: "Katarakt",
            cataractRightEye: "Katarakt rechtes Auge",
            cataractLeftEye: "Katarakt linkes Auge",
            glaucoma: "Glaukom",
            glaucomaRightEye: "Glaukom rechtes Auge",
            glaucomaLeftEye: "Glaukom linkes Auge",
            hearingLoss: "Hörverlust",
            hearingLossRightEar: "Hörverlust rechtes Ohr",
            hearingLossLeftEar: "Hörverlust linkes Ohr",
            edentulism: "Zahnlosigkeit",
            adenoidectomy: "Adenoidektomie",
            tonsillectomy: "Tonsillektomie",
            copd: "COPD",
            asthma: "Asthma",
            congenitalHeartDefect: "Angeborener Herzfehler",
            coronaryArteryDisease: "Koronare Herzkrankheit",
            hypertensiveHeartDisease: "Hypertensive Herzerkrankung",
            atrialFibrillation: "Vorhofflimmern",
            valvularHeartDisease: "Herzklappenerkrankung",
            venousInsufficiency: "Venöse Insuffizienz",
            hepaticSteatosis: "Fettleber",
            cirrhosis: "Zirrhose",
            appendectomy: "Appendektomie",
            cholecystectomy: "Cholezystektomie",
            malformativeUropathy: "Fehlbildungs-Uropathie",
            malformativeUropathyRight: "Fehlbildungs-Uropathie rechts",
            malformativeUropathyLeft: "Fehlbildungs-Uropathie links",
            renalInsufficiency: "Niereninsuffizienz",
            renalLithiasis: "Nierensteine",
            benignProstaticHyperplasia: "BPH",
            pregnancy: "Schwangerschaft",
            menopause: "Menopause",
            cesareanSection: "Kaiserschnitt",
            hysterectomy: "Hysterektomie",
            oophorectomy: "Oophorektomie",
            oophorectomyRight: "Oophorektomie rechts",
            oophorectomyLeft: "Oophorektomie links",
            scoliosis: "Skoliose",
            hipOsteoarthritis: "Hüftarthrose",
            hipOsteoarthritisRight: "Hüftarthrose rechts",
            hipOsteoarthritisLeft: "Hüftarthrose links",
            kneeOsteoarthritis: "Kniearthrose",
            kneeOsteoarthritisRight: "Kniearthrose rechts",
            kneeOsteoarthritisLeft: "Kniearthrose links",
            hipProsthesis: "Hüftprothese",
            hipProsthesisRight: "Hüftprothese rechts",
            hipProsthesisLeft: "Hüftprothese links",
            kneeProsthesis: "Knieprothese",
            kneeProsthesisRight: "Knieprothese rechts",
            kneeProsthesisLeft: "Knieprothese links",
            atopicDermatitis: "Atopische Dermatitis",
            acne: "Akne",
            psoriasis: "Psoriasis",
            hypothyroidism: "Hypothyreose",
            hyperparathyroidism: "Hyperparathyreoidismus",
            hypertension: "Bluthochdruck",
            diabetes: "Diabetes",
            dyslipidemia: "Dyslipidämie",
            hyperuricemia: "Hyperurikämie",
            bacterialPneumonia: "Bakterielle Pneumonie",
            toxoplasmosis: "Toxoplasmose",
            allergy: "Allergie",
            brainCancer: "Hirnkrebs",
            lungCancer: "Lungenkrebs",
            colonCancer: "Darmkrebs",
            pancreaticCancer: "Bauchspeicheldrüsenkrebs",
            prostateCancer: "Prostatakrebs",
            breastCancer: "Brustkrebs",
            breastCancerRight: "Brustkrebs rechts",
            breastCancerLeft: "Brustkrebs links",
            leukemia: "Leukämie",
            favorites: "Favoriten",
            left: "links",
            right: "rechts",
            in: "in",
            yearsAgo: "vor",
            years: "Jahren",
            atAge: "im Alter von",
            inChildhood: "in der Kindheit",
            since: "seit",
            sinceAge: "seit dem Alter von",
            sinceChildhood: "seit der Kindheit",
            fatherSide: "väterlicherseits",
            motherSide: "mütterlicherseits",
            rightAbbr: "R",
            leftAbbr: "L",
        },
        addEcosystem: {
            job: "Beruf:",
            workTime: "Arbeitszeit:",
            hoursPerWeek: "Stunden pro Woche",
            workTimeLabel: "Arbeitszeit: Std/Woche",
            noPartner: "Kein Partner",
            inCouple: "In einer Beziehung",
            parents: "Eltern:",
            children: "Kinder:",
            pets: "Haustiere:",
            petsValue: "Tiere:",
            violence: "Gewalt:",
            autonomousAtHome: "Selbstständig zu Hause",
            livesOnFloor: "Wohnt im",
            floor: "Stock",
            livesOnFloorLabel: "Wohnt im ... Stock",
            nursingHome: "Im Pflegeheim",
            walkingAid: "Gehhilfe:",
            homeHelp: "Häusliche Hilfe:",
            sleepLatency: "Einschlafzeit:",
            nightWakings: "Nächtliches Aufwachen:",
            averageSleepDuration: "Durchschnittliche Schlafdauer:",
            physicalActivity: "Körperliche Aktivität:",
            drinks: "Getränke:",
            diet: "Ernährung:",
            noSmoking: "Kein Rauchen",
            smoking: "Rauchen:",
            cigarettesPerDay: "Zigaretten pro Tag",
            smokingLabel: "Rauchen: ... Zig./Tag",
            noAlcohol: "Kein Alkohol",
            alcohol: "Alkohol:",
            glassesPerWeek: "Standardgläser pro Woche",
            alcoholLabel: "Alkohol: ... Gläser/Woche",
            noDrugs: "Keine Drogen",
            cannabis: "Cannabis:",
            cocaine: "Kokain:",
            opioids: "Opioide:",
            favorites: "Favoriten",
            left: "links",
            right: "rechts",
            in: "in",
            yearsAgo: "vor",
            years: "Jahren",
            atAge: "im Alter von",
            since: "seit",
            sinceAge: "seit dem Alter von",
        },
        no_entry: "Kein Eintrag",
        header: {
            report: "Bericht",
            reportWithHistory: "Bericht mit Vorgeschichte",
            reportWithHistoryShort: "Vollständiger Bericht",
            operativeReport: "Operationsbericht",
            lab: "Labor",
            pharma: "Apotheke",
            billing: "Rechnung"
        },
        expression: {
            addSigns: "Befunde hinzufügen ...",
            isCorrected: "bearbeitet",
            history: "Verlauf",
            doctor: {
                importedFor: "Importiert für:",
                by: "von: {secondaryHealthPro}",
                for: "für:",
            }
        },
        expressionMoreMenu: {
            createGroup: "Gruppe erstellen",
            rename: "Umbenennen",
            correct: "Korrigieren",
            moveToMonitored: "Zum Verlauf verschieben",
            moveToHistory: "Zu Vorgeschichte verschieben",
            moveToEcosystem: "Zu Ökosystem verschieben",
            removeFromBar: "Von der Leiste entfernen",
            nlp: "NLP",
        },        
        conclusionGroup: {
            numberedTitle: "Gruppe {number}",
            placeholder: "Plan, Rezepte ...",
        },
        suggestion: {
            sign: {
                Groups: "Gruppen",
                Measures: "Allgemein",
                CranialNerves1: "Hirnnerven",
                NeuroPeriph: "Periphere Neuro",
                MotorCoordination: "Gleichgewicht, Koordination",
                Head: "Kopf",
                Ent: "HNO",
                Thorax: "Thorax",
                Abdomen: "Abdomen",
                ShoulderL: "Schulter L",
                ShoulderR: "Schulter R",
                EllbowL: "Ellbogen L",
                EllbowR: "Ellbogen R",
                UpperArmL: "Oberarm L",
                UpperArmR: "Oberarm R",
                ForeArmL: "Unterarm L",
                ForeArmR: "Unterarm R",
                WristL: "Handgelenk L",
                WristR: "Handgelenk R",
                HandL: "Hand L",
                HandR: "Hand R",
                HipL: "Hüfte L",
                HipR: "Hüfte R",
                ThighL: "Oberschenkel L",
                ThighR: "Oberschenkel R",
                KneeL: "Knie L",
                KneeR: "Knie R",
                LowerLegL: "Unterschenkel L",
                LowerLegR: "Unterschenkel R",
                AnkleL: "Knöchel L",
                AnkleR: "Knöchel R",
                FootL: "Fuß L",
                FootR: "Fuß R",
                Lymph: "Lymphatisch",
            },
            conclusion: {
                adminPerso: "Administrativ / Persönlich",
            },
        },
        delegate: {
            title: 'Eintrag erstellen',
            label: 'Im Namen von:',
            me: ' (ich) '
        },
        search: {
            placeholder: "Name oder Matricule ...",
            noResult: "Keine Ergebnisse",
            new: "Neuen Patienten anlegen",
            invalidDate: "ungültiges Datum",
            tooLong: "Matricule zu lang",
            invalidChecksum: "Ungültiges Suffix",
            newPatient: "neuer Patient",            
        },
        create: {
            title: "Patient für {name} erstellen",
            form: {
                cns: "Matricule",
                firstname: "Vorname",
                lastname: "Nachname",
                mail: "E-Mail",
                birthdate: "Geburtsdatum",
                gender: "Geschlecht",
                address: "Adresse",
                street: "Hausnummer und Straße",
                postalCode: "Postleitzahl",
                locality: "Stadt",
                country: "Land",
                favoritePhone: "Telefon",
                mobile: "Mobil",
                import: "Aus der Zwischenablage einfügen",
                importCreate: "Patient aus der Zwischenablage erstellen",
            },
            toast: {
                success: "Die Informationen wurden automatisch abgerufen.",
                error: "Fehler beim Lesen der Zwischenablage.",
                missingBirthdate: "Geburtsdatum fehlt",
                emptyClipboard: "Zwischenablage leer",
                emptyClipboardDetail: "Kein gültiger Text zum Einfügen."
            },            
            message: {
                success: {
                    add: "Patient erfolgreich hinzugefügt"
                },
                mandatory: "Entweder Matricule oder Geburtsdatum eingeben"
            }
        },
        rightBar: {
            subtitle: {
                monitoring: "Verlauf",
                treatment: "Behandlung",
                history: "Vorgeschichte",
                ecosystem: "Ökosystem"
            },
            vaccine: "Impfungen",
        },
        imageViewer: {
            syncZoom: "Zoom sync.",
            syncPan: "Verschiebung sync.",
            close: "Schließen (Esc)",
            zoomIn: "Vergrößern (+)",
            zoomOut: "Verkleinern (-)",
            resetView: "Zurücksetzen (0)",
            scroll: "Scrollen",
            zoom: "Zoom",
            zoomInOut: "Vergrößern/Verkleinern",
            reset: "Zurücksetzen",
            pan: "Verschieben",
            closeShort: "Schließen"
        },
        ophtalmo: {
            title: "Ophthalmologie",
            correctiveLenses: "Korrekturlinsen",
            eyeGlasses: "Brille",
            contactLenses: "Kontaktlinsen",
            near: "Nah",
            distant: "Fern",
            intermediate: "Mittel",
            bifocal: "Bifokal",
            progressive: "Progressiv",
            highAmetropy: "Ametropie > 6D",
            rigid: "LRPG",
            rigidKeratoconus: "LRPG - Keratokonus",
            rigidHighAmetropy: "LRPG - Ametropie > 6D",
            leftEye: "Linkes Auge",
            rightEye: "Rechtes Auge",
            os: "LA",
            od: "RA",
            ou: "BDA",
            current: "Aktuell",
            previous: "Vorherig",
            tonometer: "Tonometer",
            iop: "IOD",
            slitLamp: "Spaltlampe",
            slitLampFindings: "Befunde",
            refraction: "Refraktion",
            objective: "Objektiv",
            subjective: "Subjektiv",
            final: "Final",
            sph: "SPH",
            cyl: "ZYL",
            axs: "ACHSE",
            va: "VA",
            add: "ADD",
            nva: "NVA",
            fundus: "Fundus",
            visualField: "Gesichtsfeld",
            oct: "OCT",
            keratometry: "Keratometrie",
            k1: "K1",
            k2: "K2",
            diopter: "D",
            noHistory: "Keine Vorgeschichte",
            export: {
                success: "Daten an Refraktor gesendet"
            },
            pachymetry: "Pachymetrie",
            topography: "Topografie",
            ultrasound: "Ultraschall",
            biometrics: "Biometrie",
        },
        resultDocument: {
            createStructuredData: "Strukturierte Daten erstellen",
            notInterpretable: "Die Gruppe enthält bereits Daten. Erstellung strukturierter Daten deaktiviert.",
            file: "Datei {mime}",
            cannotDisplay: "Kann nicht angezeigt werden. Download möglich.",
        },
        document: {
            pid: "PID",
            paid: "100% bezahlt",
            unpaid: "Unbezahlt",
            firstDay: "Von",
            lastDay: "Bis",
            newBio: "Neues Labor",
            selectFinancialGroup: "Gruppe auswählen",
            warningInvoiceExists: "Rechnung bereits vorhanden",
            finalizeTo: "Finalisieren in",
            imaging: {
                general: "Bildgebung",
                rxShort: "Rx",
                rxFull: "Röntgen",
                usShort: "Sono",
                usFull: "Sonographie",
                ct: "CT",
                mrt: "MRT",
                petScan: "PET-CT",
                other: "Andere",
            },
            healthPro: {
                medicalSpecialty: "Konsiliaranfrage",
                nurse: "Krankenschwester",
                physio: "Physiotherapeut(in)",
                ergo: "Ergotherapeut(in)",
                speech: "Logopäde/Logopädin",
                podiatrist: "Podologe/Podologin",
                pedicurist: "Fußpfleger(in)",
                dietitian: "Ernährungsberater(in)",
                psychotherapist: "Psychotherapeut(in)",
                psychologist: "Psychologe/Psychologin",
                psychomotor: "Psychomotoriktherapeut(in)",
                midwife: "Hebamme"
            },
            luBill: {
                additionalInfo: "Zusätzliche Informationen",
            },
            luBilledAct: {
                date: "Datum",
                mainLocation: "Ort",
                subLocation: "Einrichtung",
                applyHospiClassToNextActs: "Klasse {actClass} ab diesem Tag anwenden",
            },
            luBillAddon: {
                separateDates: "Daten trennen",
                codeOrAct: "Code oder Leistung ...",
                acts: "Leistungen",
                generalActs: "Allgemeine Leistungen",
                technicalActs: "Technische Leistungen",
                labActs: "Laborleistungen",
                withSupplement: "+ Zuschlag",
                personalActs: "Persönliche Leistungen",
                hospitalisation: "Krankenhausaufenthalt",
                prefix: "Präfix",
                removePrefix: "Kein Präfix",
                suffix: "Suffix",
                executor: "Ausführender",
                surgeryAssistance: "Operationsassistenz",
                customAct: {
                    description: "Beschreibung",
                    addCustomAct: "Persönliche Leistung hinzufügen",
                },
                favoriteAct: {
                    description: "Beschreibung",
                },
            },
            variableResolver: {
                patient: {
                    title: "Patient",
                    variable: {
                        patientfirstname:   "Vorname",
                        patientlastname:    "Nachname",
                        patientfullname:    "Vollständiger Name",
                        patientbirthdate:   "Geburtsdatum",
                        patientage:         "Alter",
                        patientphone:       "Telefon",
                        patientstreet:      "Straße",
                        patientcity:        "Stadt",
                        patientfulladdress: "Vollständige Adresse",
                        patientemail:       "E-Mail",
                    }
                },
                healthpro: {
                    title: "Behandler",
                    variable: {
                        profirstname:       "Vorname",
                        prolastname:        "Nachname",
                        profullname:        "Vollständiger Name",
                    }
                },
                entry: {
                    title: "Konsultation",
                    variable: {
                        currentdate:        "Datum",
                        currenttime:        "Uhrzeit",
                        currentlocation:    "Standort (Stadt)"
                    }
                }
            },
            suggestions: {
                addVariable: "Variable hinzufügen",
                autoUseFirst: "Automatisches Ausfüllen",
                autoSelection: "Automatische Auswahl",
                withConsultationDate: "mit dem Konsultationsdatum",
                withThisSelection: "mit dieser Auswahl",
                withFirstSuggestion: "mit dem 1. Vorschlag",
                required: "erforderlich:",
                minimum: "Minimum",
                examplesTitle: "Beispiele",
                examples: {
                    lines: {
                        title: "Pro Zeile",
                        subtitle: "1 Zeile = 1 Vorschlag",
                        example: "1x pro Monat\n1x pro Woche\n1x alle 2 Tage"
                    },
                    blocks: {
                        title: "Pro Block",
                        subtitle: "Mehrere Zeilen = 1 Vorschlag",
                        example: "Ich überweise diesen Patienten zur Begutachtung und Berichterstellung.\nBefund: \n ---\nIch überweise diesen Patienten dringend zur Begutachtung und Berichterstellung.\nBefund:"
                    },
                    titledBlocks: {
                        title: "Pro Block mit Titel",
                        subtitle: "Mehrere Zeilen = 1 Vorschlag",
                        example: "--- Standard\nIch überweise diesen Patienten zur Begutachtung und Berichterstellung.\nBefund: \n\n --- Dringend\nIch überweise diesen Patienten dringend zur Begutachtung und Berichterstellung.\nBefund:"
                    }
                }                
            }            
        },
        admin: {
            title: "Patient",
            relationship: {
                title: "Umfeld",
                privatePatient: "Privat (Patienten)",
                privateCustom: "Privat (Andere)",
                healthPro: "Gesundheitsfachkräfte",
            },
            invoiceHistory: "Rechnungen",
            appointments: "Termine",            
            note: "Notizen {note}",
            noteTitle: "Notizen:",
            phone: "Festnetz",
            mobile: "Mobiltelefon",
            birthday: "Geburtsdatum",
            gender: "Geschlecht",
            langs: "Sprache(n)",
            email: "E-Mail",
            invalidEmail: "Ungültige E-Mail",
            address: "Adresse",
            maps: "Anzeigen",
            ssl: "Luxemburger Sozialversicherung",
            cnsNumber: {
                add: "Matricule hinzufügen",
                title: "Nationale Gesundheitskasse",
                copied: "Kopiert"
            },
            cnsUpdate: {
                message: "CNS erfolgreich geändert",
            },
            cmcm: {
                title: "CMCM",
            },
            cmcmModify: {
                title: "Komplementäre Krankenversicherung",
                useCmcm: "CMCM registriert",
            },
            referringDoctor: {
                title: "Überweisender Arzt",
                main: {
                    full: "Hauptüberweisender Arzt",
                    short: "Haupt-ÜA",
                },
                second: {
                    full: "Vertretender überweisender Arzt",
                    short: "Vertr. ÜA",
                },
                initialDeclarationDate: "Erstdeklaration",
                declarationNumber: "Deklarations-Nr.",
                createMrDeclaration: "Deklaration erstellen",
                createMrRpa: "RPA erstellen",
            },
            doc: {
                resume: "Zusammenfassung",
                prevention: "Präventionsblatt",
                bill: "Honorarabrechnung"
            },
            subtitle: {
                contactDetail: "Kontaktdaten",
                identityDetail: "Identität",
                notificationDetail: "Benachrichtigungseinstellungen"                
            },
            subsubtitle: {
                contact: "Kontakte",
                address: "Adressen",
                healthPro: "Gesundheitsfachkräfte",
                cns: "CNS",
                cmcm: "CMCM",
                workAccident: "Arbeitsunfälle",
                referringDoctor: "Überweisender Arzt",
            },
            notification: {
                deliveryType: {
                    DELIVERY_EMAIL: 'E-Mail',
                    DELIVERY_SMS: 'Sms',
                    DELIVERY_IN_APP: 'InApp'
                },
                preferredLanguage: "Sprachpräferenz für die Kommunikation",
                error: {
                    missingContactDetails: "Eine oder mehrere Optionen sind deaktiviert, da die für den Versand von Benachrichtigungen erforderlichen Informationen nicht angegeben sind."
                },
                noDefaultEmail: "Bitte wählen Sie eine Standard-E-Mail-Adresse aus, um die Einstellungen für E-Mail-Benachrichtigungen zu ändern."
            }
        },
        cns: {
            addCard: {
                title: "Matricule",
            },
            modifyCard: {
                title: "Matricule",
                useCnsNumber: "Matricule verwenden",
            },
            editAffiliationNumberCard: {
                title: "Matricule bearbeiten",
                newCnsNumber: "Neu",
            },
        },
        entourageCard: {
            person: "Person",
            name: "Name",
            birthName: "Geburtsname",
            firstName: "Vorname",
            link: "Beziehung",
            birthDate: "Geburtsdatum",
            gender: "Administratives Geschlecht",
            biologicalSex: "Biologisches Geschlecht",
            languages: "Sprache(n)",
            note: "Notiz",
            phone: "Nummer",
            email: "E-Mail",
            street: "Straße",
            postalCode: "PLZ",
            locality: "Stadt",
            country: "Land",
            updateSuccess: "Informationen erfolgreich geändert",
        },
        actionButton: {
            accessPatient: "Akte",
            newEntry: "Neuer Eintrag",
            accessCalendar: "Termin",
            createTask: "Aufgabe",
            scrollToTop: "Zurück nach oben",
        },
        filters: {
            bio: "Labor",
            imaging: "Bildgebung",
            reports: "Berichte",
            other: "Andere",
            requests: "Rezepte",
            users: "Benutzer",
            myConsultations: "Meine Konsultationen",
        },
        pharmacy: {
            suggestions: {
                stop: "Stop",
                favorites: "Favoriten",
                lastPrescription: "Letzte Verschreibung",
                moreSubstances: "+ Substanzen",
                lessSubstances: "Weniger Substanzen",
                sameFamily: "Gleiche Familie",
                similarComposition: "Ähnliche Zusammensetzung"
            },
            prescriptionInfo: {
                patientInfos: "Patienteninformationen",
                pharmacyInfos: "Apothekeninformationen",
                autoUseFirst: "Automatisch ausfüllen",
            },
            posology: {
                then: "dann",
                asNeeded: "Bei Bedarf",
                during: "während",
                stopIn: "Stopp in",
                days: "Tag(en)",
                infos: "Infos",
                sequence: "Sequenz",
                preference: {
                    addCurrentDose: "Aktuelle Dosis hinzufügen",
                    emptyToUseSubstance: "Leer lassen, um die unten stehenden Dosierungen zu verwenden",
                    addPosologies: "Dosierungen hinzufügen",
                    posologies: "Dosierungen",
                    posologiesPlaceholder: "1 Tablette morgens und abends während 7 Tagen"
                }
            },
            title: "Maximale Verschreibungsdauer",
            customDurationDays: "Tage",
            DefaultDuration: "Standard der Verschreibung",
            CustomDuration: "Benutzerdefiniert",
            NotForPharmacy: "Nie auf Rezept",
            label: {
                DefaultDuration: "Rezept: Max. Dauer",
                CustomDuration: "Rezept: {days} Tage",
                NotForPharmacy: "Ohne Rezept"
            },
        },        
        entry: {
            time: "Uhrzeit des Eintrags",
            date: "Datum des Eintrags",
            archive: {
                header: "Diesen Eintrag löschen",
                message: "Sie sind dabei, einen Eintrag zu löschen",
                confirm: "Eintrag erfolgreich gelöscht"
            },
            archived: "Gelöscht",
            archivedBy: "Von {author} am {deletedDate} gelöscht",
            restore: {
                header: "Diesen Eintrag wiederherstellen",
                message: "Sie sind dabei, einen gelöschten Eintrag wiederherzustellen",
                confirm: "Wiederherstellung des Eintrags erfolgreich"
            }
        },
        appointments: {
            empty: "Kein Termin",
            past: "Vergangene Termine",
            coming: "Kommende Termine",
            patientFullName: "Patient",
            healthProFullName: "Gesundheitsfachkräfte",
            type: "Art des Termins",
            date: "Datum des Termins",
            time: "Zeitpunkt des Termins",
            appointmentInfo: "Kommentare zum Termin",
            duration: "Dauer des Termins",
            appointmentDetails: "Details zur Termin",
            minutes: "Minuten",
            withoutAppointment: "Ohne Termin"
        }
    },
    task: {
        taskTerm: 'Aufgabe',
        mainTitle: 'Aufgaben',
        myMissionsTitle: 'Meine Aufgaben',
        assignedMissionsTitle: 'Delegierte Aufgaben',
        twoPersonTitle: 'Chat',
        emptyState: 'Keine Aufgaben',        
        taskBoxCustomMenu: {
            addTaskBox: "Kanal hinzufügen",
        },
        twoPersonMenu: {
            addTaskBox: "Chat hinzufügen",
        },
        importFiles: {
            integrateRenamed: 'Umbenannte Dateien integrieren',
        },
        dropzone: {
            title: 'Dateien hinzufügen',
            subtitle: 'Klicken oder hierher ziehen',
        },
        noteGroup: {
            missions: "Aufgaben",
            notes: "Notizen",
            future: "Anstehend",
            validated: "Erledigt"
        },
        taskPriority: {
            DuringShift: "1 - Schnell",
            EndOfShift: "2 - Heute",
            NextDays: "3 - Nächste Tage",
            None: "4 - Weniger dringend"
        },
        notePriority: {
            DuringShift: "1 - Sehr wichtig",
            EndOfShift: "2 - Wichtig",
            NextDays: "3 - Normal",
            None: "4 - Weniger wichtig"
        },        
        since: "ab ...",
        private: "Private Notiz",
        group: {
            message: {
                success: {
                    add: "Aufgabengruppe erfolgreich erstellt",
                    deactivate: "Gruppe erfolgreich deaktiviert",
                }
            }
        },
        import: {
            regibox: {
                message: {
                    startImport: {
                        summary: "Regibox-Import gestartet",
                        detail: "Datei(en): {fileNumber}",
                    },
                    endImport: {
                        summary: "Regibox-Import",
                        detail: "Vollständige Importe: {successful}\nTeilimporte: {tasksCreated}\nFehler: {failed}\n\n{errors}",
                    },
                    missingXmlData: "Dateien ohne .xml in diesem Ordner\nBitte zuerst entfernen",
                }
            }
        },
        status: {
            Pending: "Ausstehend",
            Settled: "Validiert",
            Rename: "Umbenennen"
        },
        taskBoxDetail: {
            deactivate: "Diesen Kanal deaktivieren"
        },
        taskBox: {
            creator: "Ersteller",
        }
    },
    accounting: {
        noData: "Keine Rechnung gefunden",
        remainingBalance: "Restbetrag",
        truncated: "Begrenzte Ergebnisse",
        settled: "Bezahlt",
        transaction: "Transaktion",
        newTransaction: "Neue Transaktion",
        paymentType: "Zahlungsart",        
        search: {
            hasMore: "Begrenzte Ergebnisse, verfeinern Sie Ihre Suche",
            minCharacters: "Mind. 4 Zeichen ...",
        },
        editTransaction: {
            locked: "Diese Transaktion kann nicht mehr bearbeitet werden",
        },
        econnector: {
            service: {
                noPort: "eConnector: Port-Fehler",
                error: "eConnector: Fehler",
                technicalError: "Technischer Fehler mit eConnector",
                unspecifiedError: "Unspezifischer Fehler",
            },
            pid: {
                title: "PID",
                unavailable: "PID nicht verfügbar",
                simulationRefused: "Simulation abgelehnt",
                contest: "Anfechten",
                cnsPart: "CNS-Anteil",
                patientPart: "Patientenanteil",
                contestedOn: "Angefochten am",
                redoSimulation: "PID-Simulation wiederholen",
                confirm: "Bestätigen"
            },
            ra: {
                title: "Beschleunigte Erstattung",
                paidForCns: "BEZAHLT für CNS",
                notPaidForCns: "NICHT BEZAHLT für CNS",
                directTransmissionImpossible: "Direkte CNS-Übertragung nicht möglich",
                confirm: "Bestätigen",
                withoutEConnector: "Ohne eConnector"
            },
            sendMh: {
                toast: {
                    error: "Fehler beim Senden der Honorarabrechnung an CNS",
                    errorWithDetails: "Fehler: {details}",
                    success: "Honorarabrechnung erfolgreich an CNS übermittelt"
                }
            },
            cancelMh: {
                toast: {
                    error: "Fehler beim Stornieren der Honorarabrechnung bei CNS",
                    errorWithDetails: "Fehler: {details}",
                    success: "Honorarabrechnung erfolgreich bei CNS storniert"
                },
                alreadyCancelled: "Diese Rechnung wurde bereits storniert",
                title: "Stornierung",
                titleEconnector: "eConnector-Stornierung",
                transmittedViaEconnector: "Diese Rechnung wurde über eConnector übertragen",
                cancellationImpossibleWithoutEconnector: "Stornierung ohne eConnector nicht möglich",
                econnectorDisabled: "eConnector deaktiviert",
                econnectorUnavailable: "eConnector nicht verfügbar",
                cancelAmount: "Betrag stornieren",
                cancellationReason: "Stornierungsgrund",
                required: "Erforderlich",
                invoiceNumber: "Rechnung Nr.",
                invoiceDate: "Vom",
                total: "Gesamt"
            },
            pidSimulation: {
                toast: {
                    expiredSummary: "PID-Simulation ist abgelaufen",
                    expiredDetail: "Bitte starten Sie eine neue Simulation",
                    error: "Fehler bei der PID-Simulation",
                    errorWithDetails: "Fehler: {details}",
                    refused: "PID abgelehnt",
                    stillValid: "PID-Simulation noch gültig",
                }
            },
            pidValidation: {
                toast: {
                    error: "Fehler bei der PID-Validierung",
                    success: "PID erfolgreich validiert",
                    errorWithDetails: "Fehler: {details}",
                }
            },
            pidContestation: {
                selectAnomaly: "Bitte wählen Sie die anzufechtende Anomalie",
                selectType: "Bitte wählen Sie den Anfechtungstyp",
                type: {
                    interpretation: "Anfechtung der Interpretation einer Preisregel durch die Regel-Engine",
                    programatic: "Anfechtung eines Programmierfehlers in der Regel-Engine"
                },
                toast: {
                    error: "Fehler bei der PID-Anfechtung",
                    success: "PID erfolgreich angefochten",
                    errorWithDetails: "Fehler: {details}"
                }
            }
        },
        allMenu: {
            title: "Alle",
            precomplete: "Zu finalisieren"
        },
        financialSummary: {
            cancelled: "Storniert",
            awaitingPayment: "Zahlung ausstehend",
            revenues: "Einnahmen",
            directPayment: "Direktüberweisung",
            includeImmediatePayments: "PID und Karte in Einnahmen einbeziehen",            
        },
        financialGroupMenu: {
            disabled: "{groupName} (deaktiviert)",
            fixChannels: {
                remainingBalance: "Restbetrag",
            },
            fixGroups: {
                tpCreatedOn: "Gruppe vom {date}",
                notSubmitted: "Zu erledigen",
            },
            groupActions: {
                downloadBills: "Rechnungen herunterladen",
                downloadActs: "Leistungen herunterladen",
                downloadTransactions: "Transaktionen herunterladen",
                exportForBob50: "Export für BOB 50",                
                openPidDashboard: "Übermittlungsverlauf",
            },
            channelTransactions: {
                cancelled: "stornieren",
                bankAccount: "per Überweisung",
                cash: "bar",
                bankCard: "per Karte",
                digitalPayment: "digital",
                luTp: "per TP",
                luTpSocial: "per Sozial-TP",
                luPid: "per PID",
                remainingBalance: "unbezahlt",
            },
            channelActions: {
                createPaymentReminders: "Mahnungen erstellen",
                createLuTpSheet: "TP-Blatt erstellen",
                createLuTpSocialSheet: "Sozial-TP-Gruppe erstellen",
            },
            searchInvoice: "Rechnung",
            luTpSheet: "CNS-Auszug",
        },
        filterMenu: {
            patient: "Patient",
            date: "Datum",
            healthPro: "Arzt",
        },
        infos: {
            title: "Rechnung(en)",
        },
        stats: {
            menu: {
                title: "Verlauf",
            },
            body: {
                title: "Verlauf von: {groupName}",
                nbMHSent: "Gesendete Honorare",
                nbPidValidated: "Validierte PIDs",
                nbPidContested: "Angefochtene PIDs",
                period: "Von {start} bis {end}"
            }
        },
        invoice: {
            notCns: "Nicht-CNS",
            reminder: "Mahnung Stufe {sequence}",
            invoices: "Rechnung(en):",
        },
        invoiceReminder: {
            letter: "Brief",
            fee: "Gebühren",
            invoices: "Rechnungen: ",
            selectionAlone: "Rechnungen",
            selectionWithReminders: "Rechnungen mit Brief",
            remindersWithSettled: "Mahnungen mit anderen beglichenen Rechnungen",
            remindersNotPrinted: "{count} Mahnung(en) nicht gedruckt — seitdem beglichen",
            reminders: "Mahnungen",
            reminder: "Mahnung Nr. {sequence}",
            reminderSettings: {
                title: "Einstellungen",
                saved: "Mahnungseinstellungen",
            },
        },        
    },
    login: {
        title: "Anmeldung",
        subtitle: "Bitte wählen Sie eine Anmeldemethode, um fortzufahren",
        smartCard: "Mit LuxTrust SmartCard anmelden",
        mobile: "Mit LuxTrust Mobile anmelden",
        noAccount: "Kein Konto?",
        askToBeContacted: "Kontaktanfrage stellen",
        needHelp: "Hilfe benötigt?",
        contactUs: "Kontaktieren Sie uns",
        welcome: "Willkommen bei eSklepios",
        welcomeSubtitle: "Weniger Papierkram, mehr Pflege",
        catchphrase: "Technologie im Dienste der Gesundheit",
        description: "Profitieren Sie von leistungsstarken Tools für eine bessere Patientenversorgung",
    },
    refSheet: {
        title: "Referenz",
        list: "Referenzen",
        names: "Bezeichnungen",
        searchRefSheet: "Referenz suchen",
        selectRefSheet: "Referenz auswählen",
        assessment: {
            signs: "Befunde",
            prescriptionsFirst: "Rezepte - 1. Linie",
            prescriptionsSecond: "Rezepte - 2. Linie",
        },
        tabs: {
            Sheet: "Referenz",
            Presentation: "Krankheitsbild",
            Etio: "Ätio",
            Complic: "Kompl.",
            Treatment: "Behandlung",
            Invoice: "Abrechnung",
        },
        treatment: {
            medication: "Medikamente",
            healthPro: "Gesundheitsfachkräfte",
            administratif: "Administrativ",
        },
        invoice: {
            billingCodes: "Abrechnungscodes",
        },
        referenceDocument: {
            title: "Vorlage",
            list: "Vorlagen",
            create: "Vorlage erstellen",
            newTitle: "Titel der Vorlage",
            newTitleExample: "z. B. Erstrehabilitation oder Standardbericht",
        },
        referenceLink: {
            title: "Referenzlink",
            list: "Referenzlinks",
        },
        referenceFile: {
            title: "Referenzdatei",
            list: "Referenzdateien",
        },
        patientFile: {
            title: "Patientendokument",
            list: "Patientendokumente",
        },
    },
    posos: {
        error: {
            loading: "Fehler beim Laden des POSOS-Widgets"
        },
        unresolved: {
            drugs: "Nicht analysierte Medikamente",
            strengthMismatches: "Annäherungen",
            conditions: "Nicht analysierte Vorerkrankungen",
            allergies: "Nicht analysierte Allergien"
        }
    }
} satisfies MessageSchema;